<!--
 * @Author: vince
 * @Date: 2021-08-13 17:24:37
 * @LastEditors: vince
 * @LastEditTime: 2021-08-13 17:57:16
 * @Description: 
-->
<template>
	<div class="crumb">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item v-for="(item,index) in path" :key="index" :to="index==path.length-1?null:{name:item.name}">{{item.meta.title}}</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script>
export default {
	name: "breadcrumb",
	computed: {
		path() {
			//去掉 第一级  和 最后一级 属性为 meta: {title: "index"} 的
			let pathList=this.$route.matched.slice(1)
			if(pathList[pathList.length-1].meta.title=="index"){
				pathList.pop()
			}
			// console.log("pathList", pathList);
			return pathList;
		}
	}
};
</script>

<style lang="less" scoped>
.crumb {
	padding: 10px 20px;
	background-color: #fff;
}
</style>
